export const sourceContext = [
  {
    contextName: "Offer",
    getUrl: keys => {
      return `/offers/${keys.documentId}/${keys.siteId}`;
    }
  }
];
